import { render, staticRenderFns } from "./folders-bim.vue?vue&type=template&id=2b280b37&scoped=true"
import script from "./folders-bim.vue?vue&type=script&lang=js"
export * from "./folders-bim.vue?vue&type=script&lang=js"
import style0 from "./folders-bim.vue?vue&type=style&index=0&id=2b280b37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b280b37",
  null
  
)

export default component.exports